import React from "react";
import "./about.css";

const About = () => {
  return (
    <>
    <div className="about-app">
      <div>
        <h2>FootyTick</h2>
        <p>Website: www.footytick.com</p>
      </div>

      <div>
        <h2>Overview:</h2>
        <p>
          FootyTick is a football reference website that provides
          up-to-date listing of football clubs that have won
          the top-tier domestic league title in their respective countries. The
          website focuses on tracking which clubs have won the top league title
          and the most recent year they won it, offering fans{/*, analysts,
          journalists, and historians*/} a simple but essential reference point for
          understanding national football legacies.
        </p>
      </div>

      <div>
        <h2>Mission:</h2>
        <p>
          To bring football history to life by providing accurate, dynamic, real-time tracking of 
          when clubs last won their domestic top-tier league titles — down to the second — for football
          fans worldwide.
        </p>
      </div>


      <div>
        <h2>Vission:</h2>
        <p>
          To become the reference point for football league title history, 
          making it engaging and accessible through real-time countdowns.
        </p>
      </div>

      <div>
        <h2>Core Offering:</h2>
        <p>FootyTick is a website that:</p>
        <ul>
          <li>
            Lists football clubs that have won the highest domestic league (e.g., Premier League, 
            La Liga, Bundesliga, Serie A, etc.) in every recognized footballing nation.
          </li>
          <li>Shows the date of each club’s most recent top-tier league title win.</li>
          <li>
            Displays how long it has been since that title in real-time, auto-updating years, 
            months, weeks, days, hours, minutes, and seconds.
          </li>
          <li>
            Clean, league-by-league lists for quick
            reference.
          </li>
        </ul>
        <p>This makes FootyTick an ideal resource for:</p>
        <ul>
          <li>Football historians</li>
          <li>Statisticians and analysts</li>
          <li>Broadcasters and journalists, Podcasters</li>
          <li>Curious fans interested in historical success by nation</li>
        </ul>
      </div>

      <div>
        <h2>Key Features:</h2>

        <ul>
          <li>Champion Club Listings by Country</li>
          <li> "Last Won" Date Tracking</li>
        </ul>

        <h2> Real-Time Date (to The second):</h2>

        <ul>
          
          <li>Auto-updating counters for every listed club showing:

          <ul>
          <li>Years</li> 
          <li>Months</li> 
          <li>Weeks</li> 
          <li>Days</li> 
          <li>Hours</li> 
          <li>Minutes</li> 
          <li>Seconds since last title</li> 
          </ul>

        </li>  
        </ul>

        <h2>Global Coverage:</h2>
        <ul>
          <li>Domestic top-tier leagues.</li>
          <li>Regularly updated after each league season ends.</li>
        </ul>

        <h2> Responsive Design:</h2>
        <ul>
          <li>Optimized for desktop, tablet, and mobile.</li>
          <li>Clean and intuitive interface for fans.</li>
        </ul>


      </div>

      <div>
        <h2>Target Audience:</h2>

        <ul>
          <li>Football enthusiasts and supporters worldwide</li>
          <li>Football fans who want to track how long it’s been since their club last won the league.</li>
          <li>Football communities on social media seeking sharable stats and widgets.</li>
        </ul>
      </div>

      <div>
        <h2>Competitive Edge:</h2>

        <ul>
          <li>The only publicly accessible website that dynamically updates the timestamp (date & time to the second) of
            of the last title win for every champion club worldwide.
          </li>
          <li>Real-time updating titles display — unlike static historical lists, FootyTick shows dynamically changing counters.</li>
          <li>Comprehensive global scope — not limited to one country league.</li>
          <li>Clean, data-driven user experience optimized for football fans and professionals.</li>
        </ul>

        <p>
          Unlike broader sports statistics platforms, 
          <strong> FootyTick focuses exclusively on top-tier domestic football champions—</strong>
          providing a niche but highly valuable data set that is easy to browse,
          updated, and verified regularly. The narrow scope ensures accuracy,
          speed of updates, and high relevance.
        </p>
      </div>

      <div>
        <h2>Founding Vision:</h2>

        <p>
          Created by football lovers for football lovers, FootyTick emerged from
          a desire to answer a deceptively simple question:
          <strong> "When did this club last win the league?" </strong>
          It now answers that question for every football fan.
        </p>
      </div>
      </div>


      <div className="about-app">

      <section className="contact">
  <h2>Contact FootyTick:</h2>

  <p>
    FootyTick tracks the most recent champions of top-tier domestic football leagues
    around the world, providing fans with a clear reference point for national football history.
  </p>

  <p>
    For corrections, historical clarifications, media inquiries, or partnership opportunities,
    please contact us at:
  </p>

  <p>
    <strong>Email:</strong>
    <a href="mailto:contact@footytick.com">contact@footytick.com</a>
  </p>

  <p>
    We review all messages and aim to respond within 48 hours.
  </p>

  <p>
    For data corrections, please include the league name, club, and season
    in your message to help us review quickly.
  </p>

 <p>For partnerships or advertising, please include
  <strong>"Business Inquiry"</strong> in your subject line.</p>
</section>

<section>
  <h2>Disclaimer:</h2>

  <p>
  FootyTick strives for accuracy. League records are updated as official
  results are confirmed by governing bodies.
</p>
</section>



      </div>
    </>
  );
};

export default About;
